<template>
  <div class="mypage-next-plan-section">
    <h4 class="mypage-next-plan-section__title">
      {{ $tc('MypagePage.MypageContract.detailsPage.nextPlan') }}
    </h4>
    <div class="mypage-next-plan-section__plan">
      {{ nextPlanName }}
      <p class="mypage-next-plan-section__plan__attention" v-html="attention" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import I18n from '@/locales/I18n'

/**
 * マイページ: 契約情報 今後適用されるプラン セクション
 */
export default defineComponent({
  name: 'MypageNextPlanSection',
  props: {
    nextPlanName: {
      type: String,
      default: '',
    },
    nextPlanStartDate: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const attention = I18n.t('MypagePage.MypageContract.detailsPage.nextPlanAttention', {
      date: props.nextPlanStartDate,
    }).toString()

    return {
      attention,
    }
  },
})
</script>

<style lang="scss" scoped>
.mypage-next-plan-section {
  display: flex;
  flex-flow: row wrap;
  gap: 12px;
  width: 100%;
  padding: 0 16px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  letter-spacing: 0.02em;
  font-feature-settings: 'palt' on;
  color: $black;
  text-align: left;

  &__title {
    width: 100%;
    font-weight: 700;
  }

  &__plan {
    width: 100%;
    color: $black20;
    padding-bottom: 13px;
    border-bottom: 1px solid $black10;

    &__attention {
      width: 100%;
      margin-top: 6px;
      font-weight: 500;
      font-size: 12px;
      line-height: 1.67;
      letter-spacing: 0.02em;
      font-feature-settings: 'palt' on;
      color: $gray75;
    }
  }
}
</style>
